export enum TextCardType {
  MedicalHistory = 1,
  SurgicalHistory = 2,
  Alergies = 3,
  FamilyHistory = 4,
  DrugsInUse = 5,
  Habits = 6,
  LastDiagnosis = 7,
}

export type HighlightsInfoTextCard = {
  content: string;
  eventId?: number;
  id?: number;
  patientId?: string;
  physicianId?: number;
  clinicId?: string;
  timeCreated?: string;
  typeCard: TextCardType;
};

export type HighlightsInfoTextCardResponse = {
  content: string;
  type_card: TextCardType;
  id?: number;
  event_id?: number;
  patient_id?: string;
  physician_id?: number;
  clinic_id?: string;
  time_created?: string;
  request_uuid?: string;
};

export type GetHighlightsInfosResponse = {
  cards: HighlightsInfoTextCardResponse[];
  patient_id?: string;
  physician_id?: number;
  clinic_id?: string;
};

export type HighlightsInfoState = {
  isModalHighlightsInfoOpen: boolean;
  highlightInfoSelected?: HighlightsInfoTextCard;
  highlightInfos: HighlightsInfoTextCard[];
  isSavingLoading: boolean;
  isSavingError: boolean;
  isSavingSuccess: boolean;
  isShouldRefreshHighlightInfo: boolean;
  isGetHighlightError: boolean;
  isGetHighlightLoading: boolean;
};

export type SaveHighlightsInfoActionPayload = {
  content: string;
  patientId: string;
};

export type UserInfo = {
  profileId: string | null;
  subscriptionId: string | undefined;
  isSubscriber: boolean | null | undefined;
  clinicId: string | null;
};

export enum CardTypeTracking {
  medicalHistory = 'medical_history',
  surgicalHistory = 'surgical_history',
  alergies = 'alergies',
  familyHistory = 'family_history',
  drugsInUse = 'drugs_in_use',
  habits = 'habits',
  lastDiagnosis = 'last_diagnosis',
  custom = 'custom',
}

export enum CardInteractionTracking {
  open = 'open',
  view = 'view',
  fill = 'fill',
  close = 'close',
}

export type TrackHighlightsInfoEvents = {
  cardInteraction: CardInteractionTracking;
  cardType: CardTypeTracking;
  cardName: string;
};
